import axios from './_axios'
import {prepareParams} from './_internal'
import {AxiosResult} from './_types'

const prefix = process.env.REACT_APP_LIVESTREAMS_BASE_URL

export type Snapshot = {
  base64: string
  type: string
  size: number
}

export type testStream = {
  link: string
}

type RangeRetentionParams = {
  cameraIds: Array<number>
  startDate: number
  endDate: number
}

export class StreamingEndpoint {
  async getStream(cameraId: number): Promise<AxiosResult<string>> {
    return await axios.get(`${prefix}/open-stream/${cameraId}`)
  }

  async GetTestStream(params: testStream): Promise<AxiosResult<string>> {
    return await axios.get(`${prefix}/test`, {params: prepareParams(params)})
  }

  startStream(hashCode: string): string {
    return `${process.env.REACT_APP_LIVESTREAMS_BASE_URL}/streaming/${hashCode}.m3u8`
  }

  startStreamWithCameraId(cameraId: number, offset?: number): string {
    if (offset) return `${process.env.REACT_APP_LIVESTREAMS_BASE_URL}/live/${cameraId}?offset=${offset}`
    return `${process.env.REACT_APP_LIVESTREAMS_BASE_URL}/live/${cameraId}`
  }

  async getRangeRetention(params: RangeRetentionParams): Promise<AxiosResult<Array<number>>> {
    return await axios.post(`${prefix}/retention/range`, params)
  }

  startStreamWithTimestamp(cameraId: number, start: number, end?: number, listSize?: number): string {
    if (end) return `${process.env.REACT_APP_LIVESTREAMS_BASE_URL}/record?cameraId=${cameraId}&start=${start}&end=${end}`
    if (listSize) return `${process.env.REACT_APP_LIVESTREAMS_BASE_URL}/record?cameraId=${cameraId}&start=${start}&listSize=${listSize}`

    return `${process.env.REACT_APP_LIVESTREAMS_BASE_URL}/record?cameraId=${cameraId}&start=${start}`
  }
}
